import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Dropzone } from '@/components/Dropzone';

interface SourceUploadModalEmptyStateProps {
    onFilesSelected: (files: File[]) => Promise<void>;
}

export function SourceUploadModalEmptyState({
    onFilesSelected,
}: SourceUploadModalEmptyStateProps) {
    const { t } = useTranslation(I18nNamespace.SOURCES);

    return (
        <div className="h-full flex items-center justify-center p-8">
            <Dropzone
                className="h-full w-full"
                uploadText={t('upload.dragAndDrop')}
                onFilesSelected={onFilesSelected}
            />
        </div>
    );
}
